import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';
import { IstRegistrationsViewModalComponent } from 'src/app/ist/ist-registrations/ist-registrations-view-modal/ist-registrations-view-modal.component';
import { GrantsRegistrationsViewModalComponent } from 'src/app/grants/grants-registrations/grants-registrations-view-modal/grants-registrations-view-modal.component';
import { CommonService } from 'src/app/services/common.service';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Organization } from 'src/app/models/um/organization';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { ChangePasswordComponent } from 'src/app/personalization/change-password/change-password.component';
import * as signalR from '@microsoft/signalr';
import { serviceConstants } from 'src/app/constants/service.constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { TimezoneswitchService } from 'src/app/services/common/timezoneswitch.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  submitted = false;
  errorMess = "";
  errorMess2 = "";
  orgCode: string;
  orgId: string;
  organization: string;
  organizationObject: Organization;
  orgName: string;
  src: string;
  currentbuildversion:string;
  message: string;
  showPassword: boolean = false;
  onDisableMessage: string = "This feature is not available, please contact administrator";
  loginForm = new UntypedFormGroup({
    username: new UntypedFormControl(null),
    password: new UntypedFormControl(null)
  })

  constructor(
    private route: ActivatedRoute,
    private adminService: AdministrationSummaryService,
    private userService: UserService,
    private router: Router,
    private commonservice: CommonService,
    private modalService: NgbModal,
    private readonly timezoneSwtich: TimezoneswitchService,
    private summaryService: UmSummaryService
  ) {
    this.orgCode = route.snapshot.params['code'];
    this.src = "../../../assets/images/logo1.png";
  }

  ngOnInit() {
    const connection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(serviceConstants.apiURL + 'medrionhub')
      .build();

    connection.start().then(function (param) {
      console.trace('Medrion Hub Connected!');
    }).catch(function (err) {
      return console.error(err.toString());
    });

    connection.on("MultiBrowserLogInMessage", (resp) => {
      if (resp.data.userId == this.userService.getUserID()) {
         
        const modalRef = this.modalService.open(MessageBoxComponent, {
          backdrop: false,
          keyboard: false,
          animation: true
        });
        modalRef.componentInstance.Content={
          heading: 'Validation Message(s)',
          content: {
            heading: '',
            description: resp.data.name
          }
        }
        modalRef.result.then(result => {
          if (result == "ok") {
            this.sessionExpiry();
          }
        });
      }
    });
    this.IsLocalStorageAvailable();
    this.proceed();
    //this.currentbuildversion = this.userService.getCurrentBuildVersion();

  }
  proceed() {
    this.CurrentBuildVersion();
    this.getOrganization();
  }
  getOrganization() {
   
    if (this.orgCode !== null && this.orgCode !== undefined) {
      this.organization = this.commonservice.getOrganizationName(this.orgCode);
      this.errorMess = "";
      if (this.organization === "") {
       
        this.summaryService.GetOrgsForStorage(this.orgCode).subscribe(summary => {
          this.commonservice.setOrganizations(summary);
        //  this.userService.setCurrentBuildVersion(summary[0].VersionBuildNumber)
        //this.currentbuildversion = summary[0].VersionBuildNumber;
          this.organizationObject = this.commonservice.getOrganizationObject(this.orgCode);
          this.organization = this.organizationObject?.NAME;
          this.orgName = this.organization;
          this.orgId =this.organizationObject?.ID;
          //this.userService.setOrgCode(this.orgCode);
        
          if (this.organizationObject?.FK_ACC_ATVY_EMAILID != null && this.organizationObject?.FK_ACC_ATVY_EMAILID != '' && this.organizationObject?.FK_ACC_ATVY_EMAILID != undefined) {
            this.onDisableMessage = "";
          }
          if (this.organization === "" || this.organization === undefined || this.organization === null ) {
            // this.modalService.show(MessageBoxComponent, { data: { heading: 'Error', content: { heading: '', description: 'Wrong Organization Code. Please Contact Adminstrator.' } } });
            //alert("Wrong Organization Code");
            this.errorMess = "Wrong Organization Code";
            this.router.navigate(['404', 'Wrong Organization Code']);
          }
          else if (this.organizationObject?.RECORD_STATE === 0) {
            this.commonservice.ValidationBanner("Organization you are trying to access is inactive. Please try after some time");
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Organization you are trying to access is inactive. Please try after some time' } } });
            //alert("Organization was made inactive. Hence login into application is not possible");
            this.errorMess = "Organization was made inactive. Hence login into application is not possible";
            this.router.navigate(['404', 'Organization was made inactive. Hence login into application is not possible']);
          }
          else {
            this.userService.getLogo(this.orgCode).subscribe(result => {
              if (result === null || result === undefined || result === '') {
                this.src = "../../../assets/images/logo1.png";
              }
              else {
                if (result.FileExt == 'svg') {
                  this.src = 'data:image/svg+xml;base64,' + result.Image;
                }
                else {
                  if (result.FileExt == 'svg') {
                    this.src = 'data:image/svg+xml;base64,' + result.Image;
                  }
                  else {
                    this.src = 'data:image/png;base64,' + result.Image;
                  }
                }
              }
            });
          }
        });
      }
      else {
       
        this.orgName = this.organization;
        this.organizationObject = this.commonservice.getOrganizationObject(this.orgCode);
        if (this.organizationObject?.RECORD_STATE === 0) {
          //alert("Organization was made inactive. Hence login into application is not possible");
          this.errorMess = "Organization was made inactive. Hence login into application is not possible";
          this.router.navigate(['404', 'Organization was made inactive. Hence login into application is not possible']);
        }
        else {
          this.userService.getLogo(this.orgCode).subscribe(result => {
            if (result === null || result === undefined || result === '') {
              this.src = "../../../assets/images/logo1.png";
            }
            else {
              if (result.FileExt == 'svg') {
                this.src = 'data:image/svg+xml;base64,' + result.Image;
              }
              else {
                this.src = 'data:image/png;base64,' + result.Image;
              }
            }
          });
        }
      }
    }
    else {
      this.orgName = "IEG";
    }
  }

  ApprochLogin() {
    let browserName = this.detectBrowserName();
    const userDetails = { CODE: this.loginForm.getRawValue().username.trim(), PASSWORD: this.loginForm.getRawValue().password, ORGCODE: this.orgCode, Browser: browserName.name, Version: browserName.version }
    this.userService.userLogin(userDetails).subscribe(result => {
      if (result && (result.IS_TEMP_PWD || result.IS_FORGOT_PASSWORD) && result.USER_TYPE != 'A' && result.IsLoggedIn) {
        this.openChangePasswordPopup(result.IS_TEMP_PWD ? 'Set' : 'Reset',result);
      }
     
      else if (result && result.IsLoggedIn) {
        this.commonservice.setlocalStorageUserDetails(JSON.stringify(result));
        this.setLoginUserDetails(result);
        if(result.USER_TYPE != "A")
          {
            this.timezoneSwtich.compareCurrentTimeZoneWithSystemTimezone();
          }  
      }
      else if (result && result.IsExpired) {
        this.submitted = false;
        this.errorMess = "Licence Expired. Please Contact Administrator for support";
      }
      else if (result && result.IsBlocked) {
        this.submitted = false;
        this.commonservice.ValidationBanner('Unable to login, please contact administrator');
        // const modalRef = this.modalService.show(MessageBoxComponent, {
        //   backdrop: false,
        //   keyboard: false,
        //   ignoreBackdropClick: true,
        //   animated: true,
        //   data: {
        //     heading: 'Validation Message(s)',
        //     content: {
        //       heading: '',
        //       description: 'Unable to login, please contact administrator'
        //     }
        //   }
        // });
        //this.errorMess = "User is Blocked. Please Contact Administrator for support.";
      }
      else {
        this.submitted = false;
        this.errorMess = "Please enter valid credentials to login";
      }
    }, err => {

      // console.log(err);
    });
  }

  ActualLogin(refreshToken: string, userId: string) {
    if (refreshToken != null) {
      this.ContinueLogin(userId);
    }
    else {
      this.ApprochLogin();
    }
  }

  CurrentBuildVersion()
  {
    this.organizationObject = this.commonservice.getOrganizationObject(this.orgCode);
    this.commonservice.getCurrentVersion().subscribe(result=>{ 
       //this.organizationObject?.ID
        this.currentbuildversion = result.Data;
    })

    //this.CurrentBuildVersion = this.userService.getCurrentBuildVersion();
  }

  login() {
    this.errorMess = "";
    this.errorMess2 = "";
    if (this.loginForm.getRawValue().username === "superadmin" && this.orgCode !== undefined) {
      this.submitted = false;
      this.errorMess = "Invalid login details";
      return;
    }
    let token: any;
    let userId;
    this.submitted = true;
    let browserName = this.detectBrowserName();
    const userDetails = { CODE: this.loginForm.getRawValue().username.trim(), PASSWORD: this.loginForm.getRawValue().password, ORGCODE: this.orgCode, Browser: browserName.name, Version: browserName.version }
    this.userService.MultiBrowserVerification(userDetails).subscribe(result => {
      if (result && result.RefreshToken != null) {
        token = result.RefreshToken;
        userId = result.ID;
        let custommessage = '';
        if (result.USER_TYPE == 'A') {
          custommessage = 'You are already logged in a different window/browser. To start new login session, click on Continue button, click on Cancel to abort this login session';
        }
        else {
          custommessage = 'You are already logged in a different Window. To continue click on Continue button, click on Cancel to abort this login session';
        }
        const modalRef = this.modalService.open(DeleteBoxComponent, {
          backdrop: false,
          keyboard: false,
          animation: true
        })
        modalRef.componentInstance.Content={
          header: 'Confirmation',
          custommessage: custommessage,
          ProceedButtonName: "Continue",
          TerminateButtonName: "Cancel"
        }
        modalRef.result.then(result => {
          if (result == "okclick") {
            this.ActualLogin(token, userId);
          }
          else if (result == 'cancelclick') {
            this.userService.logout('', '', '');
          }
        });
      }
      else if (result==null || result.IsPasswordValid) {
        this.submitted = false;
        this.errorMess = "Please enter valid credentials to login";
      }
      else {
        this.ActualLogin(null, null);
      }

    }, err => {

      // console.log(err);
    });
  }

  openIST() {
    if((this.organizationObject?.FK_ACC_ATVY_EMAILID != null && this.organizationObject?.FK_ACC_ATVY_EMAILID != ''))
    {
      const modelRef= this.modalService.open(IstRegistrationsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
      });
      modelRef.componentInstance.Content={
        heading: 'Create',
        content: { RegistrationType: "IST", ORGCODE: this.orgCode, USERTYPE: "E", ORGID: this.orgId }
      }
    }
  
  }

  openEAP() {
    if((this.organizationObject?.FK_ACC_ATVY_EMAILID != null && this.organizationObject?.FK_ACC_ATVY_EMAILID != ''))
    {
      const modelRef=this.modalService.open(IstRegistrationsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
       
      });
      modelRef.componentInstance.Content= {
        heading: 'Create',
        content: { RegistrationType: "EAP", ORGCODE: this.orgCode, USERTYPE: "E" }
      }
    }
    
  }

  openGrants() {
    if((this.organizationObject?.FK_ACC_ATVY_EMAILID != null && this.organizationObject?.FK_ACC_ATVY_EMAILID != ''))
    {
      const ModelRef=this.modalService.open(GrantsRegistrationsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
      });
      ModelRef.componentInstance.Content= {
        heading: 'Create',
        content: { RegistrationType: "Grant", ORGCODE: this.orgCode, USERTYPE: "G", ORGID: this.orgId  }
      }
    }
    
  }

  delete() {
    this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
  }

  add() {

  }

  checkUser() {
    const formData = this.loginForm.value;
    const userDetails = { CODE: this.loginForm.getRawValue().username.trim(), ORGCODE: this.orgCode }
    this.userService.checkUserType(userDetails).subscribe(result => {
      if (result && result.IsLoggedIn) {
        if (result.UserLoginType === "ADMIN" || result.UserLoginType === "MED" || result.UserLoginType === "LDAP") {
          this.errorMess = "";
          this.showPassword = true;
        }
        else {
          // Write code here for redirect to SP/ID/SSO
          this.userService.getSSOConfig(result.ORGANIZATION_ID).subscribe(result => {
            if (result) {
              var sso = result;

            }
          });
        }
      }
      else
        if (formData.password !== "" && formData.password !== null && formData.username !== null && formData.username !== "") {
          this.errorMess = "Please enter valid credentials to login";
        } else {
          this.errorMess = "Please enter valid Email ID";
        }
    });
  }

  forgotPassword() {
    let modalRef = this.modalService.open(ForgotPasswordComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md pt-5',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'On-Hold',
      content: null
    }
  }

  openChangePasswordPopup(Heading: string,result:any) {
    let modalRef = this.modalService.open(ChangePasswordComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md pt-5',
      animation: true
    })
    modalRef.componentInstance.Content= {
      heading: Heading + ' Password',
      content: { old_password_field_req: false, heading: Heading }
    }

    modalRef.result.then(result => {
     
      if (result == "okclick") {
        this.userService.setOrgCode(this.orgCode);
        this.userService.setToken(result.Token);
        this.submitted = false;;
      }
    });
  }

  setLoginUserDetails(result: any) {
//localStorage.setItem('id', result.ID);
    this.userService.setLoggedUserID(result.ID)
    this.userService.setOrgCode(this.orgCode);
    this.userService.setUserDetails(result);
    this.userService.setLoggedIn(true);
    this.userService.setISTCurrency(result.IST_CURRENCY_ID);
    // this.userService.setGrants1Currency(result.GRANTS1_CURRENCY_ID);
    // this.userService.setGrants2Currency(result.GRANTS2_CURRENCY_ID);
    // this.userService.setGrants3Currency(result.GRANTS3_CURRENCY_ID);
    this.userService.setGrantsCMECurrency(result.GRANTS1_CURRENCY_ID);
    this.userService.setGrantscharitableCurrency(result.GRANTS2_CURRENCY_ID);
    this.userService.setGrantssponsorshipCurrency(result.GRANTS3_CURRENCY_ID);
    //this.userService.setCurrentBuildVersion(result.VersionBuildNumber)

    this.userService.setLoggedUserDateFormat(result.LoggedUserDateFormat);
    this.userService.setLoggedUserTimeFormat(result.LoggedUserTimeFormat);
    this.userService.setLoggedUserTimeZone(result.LoggedUserTimeZone);
    this.userService.setLoggedUserOrgTimeZone(result.LoggedUserOrgTimeZone);
    this.userService.setToken(result.Token);
    this.submitted = false;
    this.RedirectURL(result);
  }

  detectBrowserName() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bEdg\/(\d+)/)
      if (tem != null) { return { name: 'Edge(Chromium)', version: tem[1] }; }
      tem = ua.match(/\bOPR\/(\d+)/)
      if (tem != null) { return { name: 'Opera', version: tem[1] }; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return {
      name: M[0],
      version: M[1]
    };
  }

  ContinueLogin = (userId: string) => {
    let browserName = this.detectBrowserName();
    let browserNameVersion = browserName.name + browserName.version;
    
    this.userService.logoutUserInOtherBrowser(userId, browserNameVersion).subscribe((res) => {
      if (res == 200) {
        this.userService.removeUserDetails();
      }
      else {
        this.sessionExpiry();
      }
      this.ApprochLogin();
    });
  }

  sessionExpiry() {
    if (this.userService.isLoggedIn) {
      let browserName = this.detectBrowserName();
      this.userService.logout('Session Expiry due to user override', browserName.name, browserName.version);
    }

  }

  Next() {
   
    this.errorMess = "";
    this.errorMess2 = "";
    let IsPasswordValid = false;
    let IsEmailValid = true;
    const formData = this.loginForm.value;
    if (formData.username === null || formData.username === "" || formData.username === undefined) {
      this.errorMess = "Please enter Email ID";
      IsEmailValid = false;
    }
   if (formData.username !== null || formData.username !== "" || formData.username !== undefined) {
      // const mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      // if (!formData.username.match(mailformat)) {
      //   this.errorMess = "Please enter valid Email ID";
      //   IsEmailValid = false;
      // }

      let isValidEmail = this.commonservice.validateEmail(formData.username.trim())
      if (!isValidEmail) {
        this.errorMess  = "Please enter valid Email ID";
        IsEmailValid = false; 
      }

    }
    if(this.showPassword){
        if (formData.password === null || formData.password === "" || formData.password === undefined) {
        if (this.errorMess !== "") {
          this.errorMess2 = "Please enter Password";
        } else {
          this.errorMess2 = "";
          this.errorMess = "Please enter Password";
        }
        IsPasswordValid = false;
      }
      else {
        IsPasswordValid = true;
      }
    }
    if(IsEmailValid){
      this.showPassword =true;
    }
    // if (formData.password !== "" && formData.password !== null && formData.username !== null && formData.username !== "") {
    //   this.checkUser();
    // }
    // if (!this.showPassword) {

    //   if (IsEmailValid) {
    //     this.checkUser();
    //   }
    // }
    // else {
    //   if (formData.password === null || formData.password === "" || formData.password === undefined) {
    //     if (this.errorMess !== "") {
    //       this.errorMess2 = "Please enter Password";
    //     } else {
    //       this.errorMess2 = "";
    //       this.errorMess = "Please enter Password";

    //     }
    //     IsPasswordValid = false;
    //   }
    //   else {
    //     IsPasswordValid = true;
    //   }
    // }

    if (IsEmailValid && IsPasswordValid) {
      this.login();
    }
  }

  IsLocalStorageAvailable() {
  
    let userDetailsString = this.commonservice.getlocalStorageUserDetails();
    if (userDetailsString != null && userDetailsString !="") {
      let userDetails = JSON.parse(JSON.stringify(userDetailsString));
      let orgCod = this.userService.getOrgCode();
      if (orgCod != null && orgCod != "undefined") {
        if (orgCod == this.orgCode) {
          this.RedirectURL(userDetails);
        } else if (this.orgCode != null) {
          this.router.navigateByUrl(this.orgCode + '/login');
        }
      } else {
       
        if (userDetails != null && userDetails.CODE == "SUPERADMIN" && this.orgCode == undefined) {
          this.RedirectURL(userDetails);
        }
      }
    }
  }

  RedirectURL(result: any) {
    if (result.USER_TYPE === 'E' || result.USER_TYPE === 'I') {
      var len = result.FEATURES.length;
      let IsMainMenus = false;
      for (let i = 0; i < len; i++) {
        if (result.FEATURES[i].Id === 'ist') {
          IsMainMenus = true;
          if (result.USER_TYPE === 'E') {
            this.router.navigate(['/home/ist/my-applications']);
          }
          else {
            let userDetails = this.userService.getUserDetais();
            var ist = userDetails.FEATURES.filter(function (item) {
              return (item.Id == "ist")
            })[0];
            if (ist != null && ist != undefined) {
              var istall = ist.Features.filter(function (item) {
                return (item.Id == "applications")
              })[0];
              if (istall != null && istall != undefined) {
                this.router.navigate(['/home/ist/applications']);
              }
              else {
                var istmyall = ist.Features.filter(function (item) {
                  return (item.Id == "my-applications")
                })[0];
                if (istmyall != null && istmyall != undefined) {
                  this.router.navigate(['/home/ist/my-applications']);
                }
              }
            }

          }
          break;
        }
        if (result.FEATURES[i].Id === 'eap') {
          IsMainMenus = true;
          if (result.USER_TYPE === 'E') {
            this.router.navigate(['/home/eap/my-applications']);
          }
          else {

            let userDetails = this.userService.getUserDetais();
            var eap = userDetails.FEATURES.filter(function (item) {
              return (item.Id == "eap")
            })[0];
            if (eap != null && eap != undefined) {
              var eapall = eap.Features.filter(function (item) {
                return (item.Id == "applications")
              })[0];
              if (eapall != null && eapall != undefined) {
                this.router.navigate(['/home/eap/applications']);
              }
              else {
                var eapmyall = eap.Features.filter(function (item) {
                  return (item.Id == "my-applications")
                })[0];
                if (eapmyall != null && eapmyall != undefined) {
                  this.router.navigate(['/home/eap/my-applications']);
                }
              }
            }
          
          }
          break;
        }
        if (result.FEATURES[i].Id === 'grants') {
          IsMainMenus = true;
          if (result.USER_TYPE === 'E') {
            this.router.navigate(['/home/grants/my-applications']);
          }
          else {
            let userDetails = this.userService.getUserDetais();
            var grants = userDetails.FEATURES.filter(function (item) {
              return (item.Id == "grants")
            })[0];
            if (grants != null && grants != undefined) {
              var grantsall = grants.Features.filter(function (item) {
                return (item.Id == "applications")
              })[0];
              if (grantsall != null && grantsall != undefined) {
                this.router.navigate(['/home/grants/applications']);
              }
              else {
                var grantsmyall = grants.Features.filter(function (item) {
                  return (item.Id == "my-applications")
                })[0];
                if (grantsmyall != null && grantsmyall != undefined) {
                  this.router.navigate(['/home/grants/my-applications']);
                }
              }
            }
          
          }
          break;
        }
        if (result.FEATURES[i].Id == "general" || result.FEATURES[i].Id == "um" || result.FEATURES[i].Id == "productsetup" || result.FEATURES[i].Id == "auditlog" || result.FEATURES[i].Id == "analyticsconsole") {
          IsMainMenus = true;
          this.router.navigate(['/home/administration/adminconsole']);
          break;
        }
      }
      if (!IsMainMenus) {
        this.router.navigate(['home']);
      }

    }
    else if (result.USER_TYPE === 'A') {
      this.router.navigate(['/home/um/organization']);

    }
    else
      this.router.navigate(['home']);
  }

}
